import { FeatureFlag } from 'api/organizationApi';
import { User } from 'api/userApi';
import FeatureFlagWarpper from 'components/common/FeatureFlagWarpper';
import { Role } from 'models/Role';
import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

interface FeatureFlagViewProps {
  user: User;
  restrictTo?: Role[]; // Optional list of roles that can access the page
  specialFeature?: FeatureFlag; // Optional special feature required for access
  component?: React.ReactNode; // Optional component to render instead of default message
  path: string; // Path for the route
}

const FeatureFlagView = (props: FeatureFlagViewProps) => {
  return (
    <Routes>
      <Route path="/" element={<Navigate to={props.path} replace />} />
      <FeatureFlagWarpper user={props.user} featureFlag={props.specialFeature}>
        <Route path={`/${props.path}`} element={<>{props.component}</>} />
      </FeatureFlagWarpper>
    </Routes>
  );
};

export default FeatureFlagView;
